import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Form, Button, Card, Table,Col,Row,InputGroup} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";

export default function Calculate() {
    const queryParams = new URLSearchParams(useLocation().search);
    const id = queryParams.get('id');
    const [jsonData, setJsonData] = useState({});
    const [pointsData, setPointsData] = useState([]);
    const [pointsDatab, setPointsDatab] = useState([]);
    const [pointsDatac, setPointsDatac] = useState([]);
    const [PointsDatad, setPointsDatad] = useState([]);
    const [PointsDatae, setPointsDatae] = useState([]);
    const [PointsDataf, setPointsDataf] = useState([]);
    const [long, setLong] = useState([
        { leverage: "0", marginUsed: 0, unPnL: 0, bufferPercent: "0" },
      { leverage: "5", marginUsed: 51.33, unPnL: 48.57, bufferPercent: "0" },
      { leverage: "10", marginUsed: 34.54, unPnL: 65.36, bufferPercent: "0" },
      { leverage: "15", marginUsed: 26.02, unPnL: 73.88, bufferPercent: "0" },
      { leverage: "20", marginUsed: 20.88, unPnL: 79.02, bufferPercent: "0" }
    ]);
    
    const [selectedData, setSelectedData] = useState(null);


    const [error, setError] = useState(null);
    const [Qty, setQty] = useState(0);
    const [drops, setDrops] = useState(0);
    const [leverage, setLeverage] = useState(0);
    const [Ratio, setRatio] = useState(2);
    const [Capital, setCapital] = useState(0);


    
    const [captipal, setcaptipal] = useState(0);

    const [addval, setaddval] = useState(0);
    const [subval, setsubval] = useState(0);
   
    const [marketpricestatus, setmarketpricestatus] = useState(false);
    const [marketprice, setmarketprice] = useState(0);
    const [apiratiothird, setapiratiothird] = useState([]);
    const [apiratiofour, setapiratiofour] = useState([]);
    const [apiratiofive, setapiratiofive] = useState([]);
    const [FBmargin, setFBmargin] = useState(55.78);
    const [dbmargin, setdbmargin] = useState(4.2);

    const [RQ, setRQ] = useState(0);

    const [totalFullLoss, setTotalFullLoss] = useState(0);
    const [margintimes, setmargintimes] = useState(0);
    const [overalcaptotal, setoveralcaptotal] = useState(0);

    const [isDropsEdited, setIsDropsEdited] = useState(false);
    const handleCopy = () => {
        navigator.clipboard.writeText(Qty.toFixed(6));
        alert('Copied to clipboard: ' + Qty.toFixed(6));
      };
    

    useEffect(() => {
        
        console.log('Amt for Buy '+(Capital * (selectedData?.marginUsed/100)));
        console.log((Capital * (selectedData?.unPnL/100)));

        console.log('Amt for Un PnL '+ (Capital * (selectedData?.unPnL/ 100)));


        console.log('First Buy (Bin '+((Capital * (selectedData?.marginUsed/100))/ parseFloat(margintimes + 1)));

        console.log('First Buy (RQ) '+ (((Capital * (selectedData?.marginUsed/100))/ parseFloat(margintimes + 1)) * leverage) );

console.log('FB + Margin times '+parseFloat(margintimes + 1));
            console.log('margin'+ (dbmargin * ((Capital * (selectedData?.marginUsed/100))/ parseFloat(margintimes + 1))));

            console.log(' setqty '+((((Capital * (selectedData?.marginUsed/100))/ parseFloat(margintimes + 1)) * leverage) / jsonData.markPrice));
            setQty(((((Capital * (selectedData?.marginUsed/100))/ parseFloat(margintimes + 1)) * leverage) / jsonData.markPrice));



// console.log('fbrq'+((Capital * (selectedData?.marginUsed/100))/FBmargin) * leverage);



//         console.log('fmt'+((Capital * (selectedData?.marginUsed/100))/FBmargin) * dbmargin);
//         setQty((((Capital * (selectedData?.marginUsed/100))/FBmargin) * leverage) / jsonData.markPrice)

        // setQty( ((((Capital * (selectedData?.marginUsed/100))/FBmargin) * leverage) / jsonData.markPrice));

      },[leverage,Capital]);



    
    const fetchData = async () => {
        try {

            const response = await axios.get(`https://www.binance.com/fapi/v1/premiumIndex?symbol=${id}`);
            setJsonData(response.data);
        } catch (error) {
            setError("Failed to fetch data. Please try again.");
            console.error("Error fetching data:", error);
        }
    };

    const fetchPointsData = async () => {
        try {
            const response = await axios.get("https://robotecheducation.com/api/points_calls");
            setPointsData(response.data);
            setPointsDatac(response.data);
        } catch (error) {
            setError("Failed to fetch data. Please try again.");
            console.error("Error fetching data:", error);
        }
    };

    const fetchPointsDatab = async () => {
        try {
            const response = await axios.get("https://robotecheducation.com/api/two_event_calls");
            setPointsDatab(response.data);
        } catch (error) {
            setError("Failed to fetch data. Please try again.");
            console.error("Error fetching data:", error);
        }
    };

    const fetchPointsDatad = async () => {
        try {
            const response = await axios.get("https://robotecheducation.com/api/third_event_prentage");
            setPointsDatad(response.data);
        } catch (error) {
            setError("Failed to fetch data. Please try again.");
            console.error("Error fetching data:", error);
        }
    };
    const fetchPointsDatae = async () => {
        try {
            const response = await axios.get("https://robotecheducation.com/api/four_event_prentage");
            setPointsDatae(response.data);
        } catch (error) {
            setError("Failed to fetch data. Please try again.");
            console.error("Error fetching data:", error);
        }
    };
    const fetchPointsDataf = async () => {
        try {
            const response = await axios.get("https://robotecheducation.com/api/five_event_prentage");
            setPointsDataf(response.data);
        } catch (error) {
            setError("Failed to fetch data. Please try again.");
            console.error("Error fetching data:", error);
        }
    };
    const fetchratiodata = async () => {
        try {
            const response = await axios.get("https://robotecheducation.com/api/ratio_api");
            setapiratio(response.data);
        } catch (error) {
            setError("Failed to fetch data. Please try again.");
            console.error("Error fetching data:", error);
        }
    };

    const fetchratiodatathird = async () => {
        try {
            const response = await axios.get("https://robotecheducation.com/api/third_event_calls");
            setapiratiothird(response.data);
        } catch (error) {
            setError("Failed to fetch data. Please try again.");
            console.error("Error fetching data:", error);
        }
    };
    const fetchratiodatafour = async () => {
        try {
            const response = await axios.get("https://robotecheducation.com/api/four_event_calls");
            setapiratiofour(response.data);
        } catch (error) {
            setError("Failed to fetch data. Please try again.");
            console.error("Error fetching data:", error);
        }
    };
    const fetchratiodatafive = async () => {
        try {
            const response = await axios.get("https://robotecheducation.com/api/five_event_calls");
            setapiratiofive(response.data);
        } catch (error) {
            setError("Failed to fetch data. Please try again.");
            console.error("Error fetching data:", error);
        }
    };


    const [apiratio, setapiratio] = useState([]);

    const fibonacciNumbers = apiratio.map(item => Number(item.fib));

    const doublenumber = apiratio.map(item => Number(item.doubleup));

    const thirdaccnumber = apiratiothird.map(item => Number(item.percentage));

    const fouraccnumber = apiratiofour.map(item => Number(item.percentage));
    const fiveaccnumber = apiratiofive.map(item => Number(item.percentage));

    useEffect(() => {
        if(marketpricestatus == false){
        const interval = setInterval(() => {
            fetchData(); // Call fetchData every 2 seconds
        }, 2000);

        return () => clearInterval(interval); 
    }
    }, [marketpricestatus]);


    useEffect(() => {
        fetchPointsData();
        fetchratiodata();
        fetchPointsDatab();
        fetchPointsDatad();
        fetchPointsDatae();
        fetchPointsDataf();
        fetchratiodatathird();
        fetchratiodatafour();
        fetchratiodatafive();
    }, []);

    function dropbyprice(basePrice, ratio) {
        return basePrice - (basePrice / 100) * ratio;
    }

    const calculateDropPrices = () => {
        if (!jsonData.markPrice || pointsData.length === 0) return [];

        const dropPrices = [];
        let basePrice = jsonData.markPrice;

        for (let i = 0; i < drops; i++) {
            const ratio = pointsData[i]?.value || 0;
            const price = dropbyprice(basePrice, ratio);
            dropPrices.push(price);
            basePrice = price;
        }

        return dropPrices;
    };

    const dropPrices = calculateDropPrices();

    let subtotalMarginUsed = 0;
    let subtotalLoss = 0;


    let totalMarginUsed = 0;
    let totalLoss = 0;

    let royalqq = 0;

    let totaldrop = 0;
    let totalbuyvalues = 0;

    let totalLossa = 0;
    let totaldropa = 0;
    let totalbuyvaluesa = 0;
    let totalMarginUseda = 0;
   

const handleChangeval = (e) => {
    const selectedValue = e.target.value;
    setRatio(selectedValue);
    console.log("Selected value:", selectedValue);
    if(selectedValue == 1){
        setPointsData(pointsDatab)
    }else if(selectedValue == 2){
        setPointsData(pointsDatac)
    }else if(selectedValue == 3){
        setPointsData(PointsDatad)
    }else if(selectedValue == 4){
        setPointsData(PointsDatae)
    }else{
        setPointsData(PointsDataf)
    }
}

    function calculateCurrentQty(index, dropQty, totaldrop) {
        if (index === 0) return parseFloat(Qty) + parseFloat(dropQty); // For the first row

        return parseFloat(Qty) + parseFloat(totaldrop);
    }
    function tolcalculateCurrentQty(index, dropQty, totaldrop) {
        if (index === 0) return parseFloat(((Qty / leverage) * jsonData.markPrice * leverage)) + parseFloat(dropQty); // For the first row

        return parseFloat(((Qty / leverage) * jsonData.markPrice * leverage)) + parseFloat(totaldrop);
    }
    function handleChange(e) {
        // console.log(e.target.value);
        // jsonData.markPrice=e.target.value;
        setJsonData({
            "symbol": "ACTUSDT",
            "markPrice": e.target.value,
            "indexPrice": e.target.value,
            "estimatedSettlePrice": "0.18440832",
            "lastFundingRate": "0.00005000",
            "interestRate": "0.00005000",
            "nextFundingTime": 1738310400000,
            "time": 1738307467000
          })
    }
function Pricetable({ setTotalFullLoss }) {
    let totalMarginUsed = 0;
    let totalLoss = 0;
    let totaldrop = 0;
    let totalbuyvalues = 0;
    let royalqq = 0;
    let cumulativeQty = (((Qty / leverage) * jsonData.markPrice) * leverage); 
let buyvalue=RQ;
let sumbuyvalue=RQ;
let totalfulllose=0;
let totalmultration=0;
let totalcaptialneed=((Qty / leverage) * jsonData.markPrice);
let capcaltotal=0;

let fbmargintimecount=0;
let currentqty=Qty;

let totalLosscal=0;
let cummarginbinace=((Qty / leverage) * jsonData.markPrice);

useEffect(() => {
    setTotalFullLoss(totalLosscal);
}, [totalLosscal]);



useEffect(() => {
    if (pointsData.length > 0 && !isDropsEdited) {
        setDrops(pointsData.length);
      }

}, [pointsData]);


useEffect(() => {
 
        setmargintimes(totalmultration);
  
    
    }, [totalmultration]);

    
    useEffect(() => {
 
        setoveralcaptotal(capcaltotal);
  
    
    }, [capcaltotal]);


    

    return (
        
<Table striped bordered hover style={{ marginTop: '5%', display: Ratio == 4 || Ratio == 5 ? 'none' : '' }}>
                        <thead>
                            <tr>
                                <th>No. Of Drops</th>
                                <th>Margin Call Drop</th>
                                <th>Drop Buy Price</th>
                                <th>Multi Buy Ratio</th>
                                <th>Drop Buy Qty</th>
                                <th>RoyalQ</th>
                                <th>Binance</th>
                               
                                {/* <th>UnRealised P/L</th> */}
                                <th>Current qty</th>
                                <th>Total Buy Value</th>
                                <th>Loss</th>
                                <th>Cum. Margin Used Binance</th>
                            </tr>
                        </thead>
                        <tbody>
                            
                            {pointsData.slice(0, drops).map((item, index) => {
                                const dropPrice = dropPrices[index];


                                
                                const prevDropPrice = dropPrices[index - 1] || "-";
                             
                                    


                                // const buyRatio = Ratio == 1 ? doublenumber[item.id - 1] : fibonacciNumbers[item.id - 1] : thirdaccnumber[item.id - 1];
                                let buyRatio;
                                if(Ratio == 1){
                                buyRatio=doublenumber[item.id - 1];
                             }else if(Ratio == 2){
                                buyRatio= fibonacciNumbers[item.id - 1];
                             }else if(Ratio == 3){
                                buyRatio= thirdaccnumber[item.id - 1];
                             }else if(Ratio == 4){
                                buyRatio= fouraccnumber[item.id - 1];
                                
                             }else{
                                buyRatio= fiveaccnumber[item.id - 1];
                             }
                             

                             totalmultration +=buyRatio;
                                const dropQty = buyRatio * Qty;

                                // cumulativeQty += parseFloat(dropQty.toFixed(7));
                                const currentQty_full = parseFloat(cumulativeQty.toFixed(7));

                                


                                const futureBuy = dropQty * dropPrice;


                                cumulativeQty +=futureBuy;

                                
                                const marginUsed = futureBuy / leverage;

                                totalMarginUsed += marginUsed;

                                totaldrop += dropQty;
                                const currentQty = calculateCurrentQty(index, dropQty, totaldrop);
                                totalbuyvalues += futureBuy;
                                const toltotalbuyvalues = tolcalculateCurrentQty(index, futureBuy, totalbuyvalues);
                                const loss = Math.abs(toltotalbuyvalues - currentQty * dropPrice);
                                totalLoss += loss;
                                royalqq +=futureBuy;


                                sumbuyvalue += parseFloat(futureBuy.toFixed(7));
                                const totalcurrentQty_full = parseFloat(sumbuyvalue.toFixed(7));
                               totalfulllose =((parseFloat(cumulativeQty) - (parseFloat(currentqty.toFixed(7)) * parseFloat(dropPrice))));
                               totalcaptialneed +=marginUsed;
                               currentqty +=dropQty;
                               totalLosscal=(parseFloat(cumulativeQty) - (parseFloat(currentqty.toFixed(7)) * parseFloat(dropPrice)));
                               cummarginbinace +=marginUsed;
                               capcaltotal = cummarginbinace;

                               return (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{item.value}</td>
                                        <td>
                                            {dropPrice}

                                        </td>
                                        <td>{buyRatio}</td>
                                        <td>{dropQty}</td>
                                        <td>{futureBuy}</td>
                                        <td>{marginUsed}</td>
                                        
                                        {/* <td>{loss}</td> */}
                                        <td>{currentqty}</td>
                                        <td>{cumulativeQty}</td>
                                        <td>{(parseFloat(cumulativeQty) - (parseFloat(currentqty.toFixed(7)) * parseFloat(dropPrice)))}</td>
                                        <td>{cummarginbinace}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="4"></td>
                                <td  style={{ textAlign: "center" }}>Grand Total:</td>
                                <td>{royalqq}</td>
                                <td>{totalMarginUsed}</td>
                                <td>{totalLoss}</td>
                                <td></td>
                                <td></td>
                                <td>{totalfulllose} </td>
                            </tr>
                        </tfoot>
                    </Table>

    ); 
}
    return (
        <div>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
            <Card style={{ width: '100%', padding: '3%' }}>
                <Card.Body className='table-responsive'>
                    <Card.Title>{marketpricestatus == false ? (<div>
                        {id} / <b style={{ color: 'red' }}>${jsonData && jsonData.markPrice}</b> <Button onClick={() => setmarketpricestatus(!marketpricestatus)} variant="success">
                        Coin Price <i className="fa fa-refresh"></i>
                        </Button>
                    </div>
                    ) : (
                        <div>
                           
                            <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                                <Form.Label column sm="2">
                                    <Form.Control type="number" placeholder="Coin Price" onChange={handleChange} />
                                </Form.Label>
                                <Col sm="10">

                                    <Button onClick={() => setmarketpricestatus(!marketpricestatus)} variant="success">
                                        Market Price <i className="fa fa-refresh"></i>
                                    </Button>
                                </Col>
                            </Form.Group>
                        </div>
                    )}
                    </Card.Title>
                    
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput2">
                            <Form.Label>Leverage</Form.Label>
                            
                            
                            <Form.Control
                                        as="select"
                                        value={leverage}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setLeverage(selectedValue);

                                            // Find matching leverage object from 'long' array
                                            const match = long.find(item => item.leverage === selectedValue);
                                            setSelectedData(match || null); // store match or null
                                        }}
                                        >
                                        <option value="0">Select Leverage</option>
                                        <option value="5">5x</option>
                                        <option value="10">10x</option>
                                        <option value="15">15x</option>
                                        <option value="20">20x</option>
                                        </Form.Control>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlSelect1">
                            <Form.Label>Capital Mode</Form.Label>
                            <Form.Select aria-label="Default select example" onChange={handleChangeval} >

                            <option value="2">Minimum Capital/Profit</option>
                                        <option value="3">Medium Capital/Profit</option>
                                        <option value="1">Higher Capital/Profit</option>
                                        <option value="4">Solo defender </option>
                                        <option value="5">RT Technical Team</option>
                            </Form.Select>
                        </Form.Group>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Capital Available Per Trade</Form.Label>
                            <Form.Control
                                type="number"
                                placeholder="Capital Available for Trade"
                                value={Capital}
                                onChange={e => setCapital(e.target.value)}
                            />
                        </Form.Group>  


                    
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput3" style={{ display: Ratio == 4 || Ratio == 5 ? 'none' : '' }}>
                            <Form.Label>No. of Drops</Form.Label>
                            <Form.Control
                             readOnly
  type="number"
  placeholder="Drops"
  value={drops}
  onChange={e => {
    setDrops(e.target.value);
    setIsDropsEdited(true);
  }}
/>
                        </Form.Group>
                        <Form>
      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
        <Form.Label>First Buy Qty</Form.Label>
        <InputGroup>
          <Form.Control 
            readOnly
            type="number"
            placeholder="First Buy Qty"
            value={Qty.toFixed(6)}
            onChange={e => setQty(e.target.value)}
          />
          <Button variant="outline-secondary" onClick={handleCopy}>
            Copy
          </Button>
        </InputGroup>
      </Form.Group>


                               


                        

                       

                        
                    </Form>



                    <Table striped bordered hover responsive style={{ marginTop: '5%',display:'none'}}>
                        <thead>
                            <tr>
                                <th>No. Of Drops</th>
                                <th>Margin Call Drop</th>
                                <th>Drop Buy Price</th>
                                <th>Multi Buy Ratio</th>
                                <th>Drop Buy Qty</th>
                                <th>RoyalQ</th>
                                <th>Binance</th>
                                
                                <th>UnRealised P/L</th>
                                <th>Current qty</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pointsData.slice(0, drops).map((item, index) => {
                                const dropPrice = dropPrices[index];
                                const prevDropPrice = dropPrices[index - 1] || "-";
                                // const buyRatio = Ratio == 1 ? doublenumber[item.id - 1] : fibonacciNumbers[item.id - 1];
                                let buyRatio;
                                if(Ratio == 1){
                                    buyRatio=doublenumber[item.id - 1];
                                 }else if(Ratio == 2){
                                    buyRatio= fibonacciNumbers[item.id - 1];
                                 }else if(Ratio == 3){
                                    buyRatio= thirdaccnumber[item.id - 1];
                                 }else{
                                    buyRatio= fouraccnumber[item.id - 1];
                                    
                                 }
                             
                             
                                const dropQty = buyRatio * Qty;
                                const futureBuy = dropQty * dropPrice;
                                const marginUsed = futureBuy / leverage;

                                totalMarginUsed += marginUsed;
                                subtotalMarginUsed = marginUsed;
                                totaldrop += dropQty;
                                const currentQty = calculateCurrentQty(index, dropQty, totaldrop);
                                totalbuyvalues += futureBuy;
                                const toltotalbuyvalues = tolcalculateCurrentQty(index, futureBuy, totalbuyvalues);
                                const loss = Math.abs(toltotalbuyvalues - currentQty * dropPrice);
                                totalLoss += loss;
                                subtotalLoss = loss;

                                royalqq += futureBuy;
                                return (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{item.value}</td>
                                        <td>
                                            {dropPrice}

                                        </td>
                                        <td>{buyRatio}</td>
                                        <td>{dropQty}</td>
                                        <td>{futureBuy}</td>
                                        <td>{marginUsed}</td>
                                        
                                        <td>{loss}</td>
                                        <td></td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="5" style={{ textAlign: "right" }}>Grand Total:</td>
                                <td>{royalqq}</td>
                                <td>{totalMarginUsed}</td>
                                <td>{totalLoss}</td>
                            </tr>
                        </tfoot>
                    </Table>

                    <Table striped bordered hover  style={{ marginTop: '5%' }}>
                        
                        <thead>
                            <tr>
                                <th>1 st Buy Margin Used In Binance</th>
                                <th>{(Qty / leverage) * jsonData.markPrice}</th>

                            </tr>
                        </thead>
                        <thead>
                            <tr>
                                <th>First Buy in USDT RoyalQ</th>
                                <th>{(((Qty / leverage) * jsonData.markPrice) * leverage)}</th>

                            </tr>
                        </thead>
                        <thead style={{ display: Ratio == 4 || Ratio == 5 ? 'none' : '' }}>
                            <tr>
                                <th>First Buy Qty (Coin)</th>
                                <th>{Qty}</th>

                            </tr>
                        </thead>
                        <thead style={{ display: Ratio == 4 || Ratio == 5 ? 'none' : '' }}>
                            <tr>
                                <th>Final DropLoss</th>
                                <th>{totalFullLoss}</th>

                            </tr>
                        </thead>
                        <thead style={{ display: Ratio == 4 || Ratio == 5 ?  'none' : '' }}>
                            <tr>
                                <th>FB + Margin times</th>
                                <th>{margintimes+ parseFloat(1)}</th>

                            </tr>
                        </thead>
                        {/* <thead>
                            <tr style={{background: '#4B49AC',color:'white'}}>
                                <th style={{background: '#4B49AC',color:'white'}}>Capital Need</th>
                                <th style={{background: '#4B49AC',color:'white'}}>{totalMarginUsed + subtotalLoss + ((Qty / leverage) * jsonData.markPrice)}</th>

                            </tr>
                        </thead> */}
                        <thead>
                            <tr style={{background: '#4B49AC',color:'white'}}>
                                <th  style={{background: '#4B49AC',color:'white'}}>Capital by calculation</th>
                                <th  style={{background: '#4B49AC',color:'white'}}>{overalcaptotal+totalFullLoss}</th>

                            </tr>
                        </thead>

                        
                    </Table>
                    <Pricetable setTotalFullLoss={setTotalFullLoss} />
                </Card.Body>
            </Card>
        </div>
    );


}
